<template>
  <div class="mock-mobile full-page-section" :class="{ indi : tagString === 'independent' }">
    <div style="position: absolute; height: 100%; width: 100%;">
      <div class="time-line">
        <div>
          <span>03:34</span>
        </div>
      </div>
      <div class="tag">{{tagString}}</div>
      <transition name="fade">
        <div
          class="info-circle circle-1"
          :style="circle1Style"
        >
          This is a tag for explicit music.
        </div>
      </transition>
      <transition name="fade">
        <div
          class="info-circle circle-2"
          :style="circle2Style"
        >
          We want to add one for independent music!
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MockMobile',
  props: {
    procent: Number
  },
  computed: {
    tagString () {
      return (this.procent < 90) ? 'explicit' : 'independent'
    },
    circle1Style () {
      let animations = [
        {
          prop: 'opacity',
          speed: 1.6,
          from: 0,
          start: -0.15,
          end: 0.5
        },
        {
          prop: 'scale',
          speed: 2,
          from: 0,
          start: -0.15,
          end: 0.5
        },
        {
          prop: 'translateY',
          speed: -0.03,
          from: 0,
          start: -0.15,
          end: 0.5
        }
      ]
      return this.animate((this.procent / 100), animations)
    },
    circle2Style () {
      let animations = [
        {
          prop: 'opacity',
          speed: 4,
          from: 0,
          start: 0.2,
          end: 1.8
        },
        {
          prop: 'scale',
          speed: 1.8,
          from: 0,
          start: 0.2,
          end: 1.0
        },
        {
          prop: 'translateY',
          speed: -0.1,
          from: 0,
          start: 0.2,
          end: 1.3
        }
      ]
      return this.animate((this.procent / 100), animations)
    }
  },
  watch: {
    procent () {
    }
  },
  methods: {
    //  Input: element, type of change, total, at
    //  Output: style
    animate (at, animations) {
      let style = {}
      let self = this
      animations.forEach(ob => {
        let ass = self.animateProp(at, ob.prop, ob.speed, ob.from, ob.start, ob.end)
        if (!ass) return
        let key = Object.keys(ass)[0]
        if (style[key]) {
          style[key] += ' ' + ass[key]
          return
        }
        style[key] = ass[key]
      })
      return style
    },
    animateProp (at, styleProp, speed, from, start, end) {
      if (at < start || at > end) return false
      let procentAt = ((at - start) / (end - start)) * 100
      return this.getPropTypeObj(styleProp, (per) => {
        return (from + (procentAt * per)) * speed
      })
    },
    getPropTypeObj (propType, fun) {
      if (propType === 'opacity') return { opacity: fun(0.01) }
      if (propType === 'translateY') return { transform: 'translateY(' + fun(1) + 'px)' }
      if (propType === 'scale') return { transform: 'scale(' + fun(0.01) + ')' }
    }
  },
  mounted () {
    //  console.log(this.animate(0.5, 'opacity', 0.01, 0, 0.2, 0.9))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mock-mobile {
  background-image: url('../assets/new/mobile-mock.png');
  background-size: auto 66%;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  z-index: 99;
  transition: all 0.3s ease;
  &.indi {
    background-image: url('../assets/new/mobile-mock-after.png');
  }
  .tag {
    display: none;
    font-size: 1.1vh;
    background-color: #9d9d9c;
    left: 50%;
    position: absolute;
    top: 61.2%;
    transform: translateX(-50%);
    border-radius: 4px;
    color: #fff;
    padding: 0.1vh 1vh;
    text-transform: uppercase;
  }
  .info-circle {
    width: 12vh;
    height: 12vh;
    background-color: #ffff76;
    color: #ff5555;
    border-radius: 50%;
    left: calc(48% - 15vh);
    position: absolute;
    top: 52%;
    font-size: 1.36vh;
    line-height: 1.3em;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2vh;
    box-shadow: 3px 3px 43px -9px rgba(0,0,0,0.76);
    transition: all 0.2s ease;
    opacity: 0;
    &.circle-2 {
      left: auto;
      right: calc(48% - 15vh);
    }
    &.far-out {
      box-shadow: 3px 3px 143px -9px rgba(0,0,0,0.76);
      transform: scale(2.2);
    }
  }
  .time-line {
    width: 18vh;
    left: calc(50% - 9vh);
    position: absolute;
    top: 51vh;
    text-align: left;
    color: #000;
    display: none;
    border-bottom: 2px solid #919190;
    div {
      text-align: right;
      position: relative;
      bottom: -2px;
      padding-bottom: 0.5vh;
      font-size: 1vh;
      display: inline-block;
      width: 76%;
      border-bottom: 2px solid #000;
      span {
        display: inline-block;
        transform: translateX(40%);
      }
      &:after {
        content: ' ';
        position: absolute;
        bottom: -4px;
        height: 7px;
        width: 7px;
        background-color: #000;
        right: 0px;
        border-radius: 7px;
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: all 2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.3);
}
</style>
